import { BasePaymentPlan, List } from "@elton/types";

import { getServicesClient } from "@/api/clients/api-client";

export const getBasePaymentPlans = async () => {
  const res = await getServicesClient().get<List<BasePaymentPlan>>(`/plans`);

  return res.data;
};
